/**
 * Decode HTML entities (e.g. &#x26; or &amp;) so symbols display correctly in plain text.
 * Use when displaying strings that were extracted from HTML and may contain entities.
 */
export function decodeHtmlEntities(str: string): string {
  if (!str || typeof str !== 'string') return str;
  try {
    const doc = new DOMParser().parseFromString(str, 'text/html');
    return doc.documentElement.textContent ?? str;
  } catch {
    return str;
  }
}
